// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"KD-z","smallCardRow":"LD-z","largeCardRow":"MD-z","productSearchRow":"ND-z","curatedRow":"OD-z"};